<!--价格-->
<template>
  <div>
    <div
      class="discount"
      v-if="isShowDiscount"
    >
      <!--  分期价格  -->
      <div class="priceModule-installment">
        <h3 class="installment-title">优惠</h3>
        <div class="discount-box">
          <!-- 联报 -->
          <div
            class="discount-hb"
            @click="openActivity('jointReport')"
            v-if="
            allAcvitity.productDetailUnionPromotionResp &&
              allAcvitity.productDetailUnionPromotionResp.promotionProductRespList.length > 1
          "
          >
            <div class="discount-hb-left">
              <TagComponent text="联报" />
              <span
                class="installment-content"
                v-if="allAcvitity.productDetailUnionPromotionResp"
              >
                参与联报可立减{{
                allAcvitity.productDetailUnionPromotionResp.maxUnionDiscountPrice
              }}元</span>
            </div>
            <img
              src="../../../assets/img/productDetail/icon_right.png"
              class="right-icon"
              alt=""
            />
          </div>
          <!-- 满减 -->
          <div
            class="discount-hb"
            @click="openActivity('fullReduction')"
            v-if="
            allAcvitity.productDetailFullPromotionRespList &&
              allAcvitity.productDetailFullPromotionRespList.length > 0
          "
          >
            <div class="discount-hb-left">
              <TagComponent text="满减" />
              <span class="installment-content">
                {{fullReductionText(allAcvitity.productDetailFullPromotionRespList)}}
              </span>
            </div>
            <img
              src="../../../assets/img/productDetail/icon_right.png"
              class="right-icon"
              alt=""
            />
          </div>
          <!-- 优惠券 -->
          <!-- <div
          class="discount-hb"
          @click="openCouponAcvitity"
          v-if="couponDetail.couponId"
        >
          <div class="discount-hb-left">
            <div class="discountAmount">
              {{ couponDetail.discountAmount }}{{ couponDetail.discountType === 1 ? `元` : `折` }}
            </div>
            <p
              class="usableCondition"
              v-if="couponDetail.discountType === 1"
            >
              满{{ couponDetail.usableCondition }}减{{ couponDetail.discountAmount }}
            </p>
            <p
              class="usableCondition"
              v-else
            >
              满{{ couponDetail.usableCondition }}打{{ couponDetail.discountAmount }}折
            </p>
          </div>
          <div class="open">
            <span>领券</span><img
              src="../../../assets/img/productDetail/icon_right_color.png"
              class="right-icon"
              alt=""
            />
          </div>
        </div> -->
          <!-- 分期  放开注释时需要同时修改isShowDiscount-->
          <!-- <div class="discount-hb" v-if="canInstallment && by_stages_price > 0">
          <div class="discount-hb-left">
            <TagComponent text="分期付款"/>
            <span class="installment-content">分期支付 ¥ {{ by_stages_price }} 起</span>
          </div>
        </div> -->

          <!-- 增加买赠活动赠品（优惠券） -->
          <div
            v-if="wholeGiftlist"
            class="discount-hb"
            @click="giveCouponList"
          >
            <div class="discount-hb-left">
              <TagComponent text="赠券" />

              <span
                v-for="(item, index) in wholeGiftlist.slice(0, 2)"
                :key="index"
                class="taxPreference"
              >{{item.discountType === 1? `满`+item.usableCondition+`减`+ item.discountAmount : `满`+item.usableCondition+`打`+item.discountAmount +`折`}}</span>
            </div>
            <img
              src="../../../assets/img/productDetail/icon_right.png"
              class="right-icon"
              alt=""
            />
          </div>

          <!-- 增加赠品(买课赠实物活动) -->
          <div
            v-if="giftMaterialList"
            class="discount-hb"
            @click="giveGiftsList"
          >
            <div class="discount-hb-left">
              <TagComponent text="赠品" />
              <span class="taxPreference addEllips">
                {{giftMaterialList[0].materialName}}
              </span>
            </div>
            <img
              src="../../../assets/img/productDetail/icon_right.png"
              class="right-icon"
              alt=""
            />
          </div>
        </div>
      </div>
      <!-- 联报与满减弹窗 -->
      <component
        :is="coursePopType | typeToComponentName"
        :showActivity="showActivity"
        :defaultSelectCourse="defaultSelectCourse"
        :allActivity="allAcvitity"
        :activityData="allAcvitity.productDetailUnionPromotionResp"
        ref="popupRef"
        @close="close"
      />
      <!--     <JointPreferencesDetail
      :showAcvitity="showAcvitity"
      :defaultSelectCourse="defaultSelectCourse"
      :activityData="allAcvitity.productDetailUnionPromotionResp"
      @close="close"
    /> -->

      <!-- 赠品优惠券列表 -->
      <GiveCouponPop
        v-if="GiveCouponShow"
        @giveCouponClose="giveCouponClose"
        :wholeGiftlist="wholeGiftlist"
      />
      <!-- 赠品实物列表 -->
      <GiveGiftsPop
        v-if="GiveGiftsShow"
        @giveGiftsClose="giveGiftsClose"
        :giftMaterialList='giftMaterialList'
      />
    </div>
    <div
      class="couponBoxWarrp"
      v-if="isShowCoupon"
    >
      <div
        class="couponBoxCenter"
        @click="openCouponAcvitity"
        v-if="couponDetail.couponId"
      >
        <div class="couponDisType">
          <div class="discountAmount">
            {{ couponDetail.discountAmount }}{{ couponDetail.discountType === 1 ? `元` : `折` }}
          </div>
          <div>
            <p
              class="usableCondition"
              v-if="couponDetail.discountType === 1"
            >
              满{{ couponDetail.usableCondition }}减{{ couponDetail.discountAmount }}
            </p>
            <p
              class="usableCondition"
              v-else
            >
              满{{ couponDetail.usableCondition }}打{{ couponDetail.discountAmount }}折
            </p>
            <p
              class="timeCount"
              v-if="showTime"
            >限时抢券：{{showTime}}</p>
          </div>

        </div>
        <div class="openCouList">
          立即领取
        </div>
      </div>
      <!-- 优惠券列表 -->
      <CouponList ref="couponList" />
    </div>

  </div>

</template>

<script>
import { mapState } from 'vuex';
// eslint-disable-next-line import/extensions
import TagComponent from '@/components/commonComponents/TagComponent';
// eslint-disable-next-line import/extensions
import FullReductionPop from '@/components/courseDetail/fullReduction/FullReductionPop'; // 满减
import GiveCouponPop from '@/components/courseDetail/giveCouponPop.vue';
import GiveGiftsPop from '@/components/courseDetail/giveGiftsPop.vue';
import { replaceHyphens, timerYhqCount } from '@/utils/tools';
import JointPreferencesDetail from '../../../components/jointPreferences/jointPreferencesDetail.vue'; // 联报
import CouponList from '../../coupon/couponList.vue';

export default {
  components: {
    JointPreferencesDetail,
    CouponList,
    TagComponent,
    FullReductionPop,
    GiveCouponPop,
    GiveGiftsPop,
  },
  props: {
    by_stages_price: {
      // 分期价格
      type: [Number, String],
    },
    wholeGiftlist: {
      type: Array,
      default: () => { },
    },
    giftMaterialList: {
      type: Array,
      default: () => { },
    },

  },
  filters: {
    /** 根据type找到组件 */
    typeToComponentName(val) {
      let componentName;
      if (val === 'fullReduction') {
        componentName = 'FullReductionPop';
      } else if (val === 'jointReport') {
        componentName = 'JointPreferencesDetail';
      }
      return componentName || '';
    },
  },
  data() {
    return {
      defaultSelectCourse: [], // 默认选中的主产品
      showActivity: false, // 是否展示联报详情
      couponDetail: {}, // 最优的优惠券
      salePrice: 0,
      coursePopType: '',
      // isShowDiscount: false,
      GiveCouponShow: false, // 赠券弹窗
      courseId: this.$route.query.courseId, // 课程id
      GiveGiftsShow: false, // 赠品弹窗
      timers: null,
      showTime: '', // 倒计时

    };
  },
  computed: {
    ...mapState(['courseBaseData', 'productSku', 'allAcvitity', 'buyStatus']),
    // 是否可分期
    canInstallment() {
      return this.salePrice >= 100;
    },
    // 是否展示优惠信息
    isShowDiscount() {
      const {
        status,
        isValid,
        validPeriodType,
        isSetStock,
        availableStock,
        isRepeatBuy,
        productId,
      } = this.courseBaseData;
      const { productDetailUnionPromotionResp, productDetailFullPromotionRespList } = this.allAcvitity;
      // 未上架 || 已过期 || 已售罄 || 已下架 || 已购买且不可重复购买
      if (
        status <= 3
        || (!isValid && validPeriodType !== 1 && productId)
        || (isSetStock === 1 && availableStock <= 0)
        || status === 6
        || (this.buyStatus.length && isRepeatBuy === 0)
      ) {
        return false;
      }

      // eslint-disable-next-line no-unused-vars
      let flag = false;
      /* if (this.canInstallment && this.by_stages_price > 0) {
        // 分期 分期整改暂时隐藏
        flag = true;
      } */
      // if (this.couponDetail.couponId) {
      // 优惠卷
      // flag = true;
      // }
      if (productDetailUnionPromotionResp?.promotionProductRespList?.length > 1) {
        // 联报
        flag = true;
      } else if (productDetailFullPromotionRespList?.length > 0) {
        // 满减
        flag = true;
      } else if (this.wholeGiftlist) {
        // 是否带赠送的优惠券
        flag = true;
      } else if (this.giftMaterialList) {
        // 是否带赠送的实物
        flag = true;
      }
      return flag;
    },
    isShowCoupon() {
      const {
        status,
        isValid,
        validPeriodType,
        isSetStock,
        availableStock,
        isRepeatBuy,
        productId,
      } = this.courseBaseData;
      // 未上架 || 已过期 || 已售罄 || 已下架 || 已购买且不可重复购买
      if (
        status <= 3
        || (!isValid && validPeriodType !== 1 && productId)
        || (isSetStock === 1 && availableStock <= 0)
        || status === 6
        || (this.buyStatus.length && isRepeatBuy === 0)
      ) {
        return false;
      }

      // eslint-disable-next-line no-unused-vars
      let flag = false;
      if (this.couponDetail.couponId) {
        // 优惠卷
        flag = true;
      }
      return flag;
    },
  },
  watch: {
    productSku(data) {
      // 获取sku的价格
      this.salePrice = data.productSkuId ? data.price : this.courseBaseData.sellPrice;
      this.defaultSelectCourse = [
        {
          productId: this.courseBaseData.productId,
          skuId: data.productSkuId,
          ...this.courseBaseData,
        },
      ];
    },
    courseBaseData(data) {
      // 默认取产品的价格
      this.salePrice = data.sellPrice;
    },
    allAcvitity(data) {
      if (data.couponDetailVO) {
        const idx = 0;
        this.couponDetail = data.couponDetailVO.couponChooseRespList[idx];
        this.countTime();
      }
    },
  },
  mounted() {
    this.salePrice = this.courseBaseData.productId && this.courseBaseData.sellPrice;
  },
  methods: {
    fullReductionText(val) {
      const textArr = [];
      val.forEach((item) => {
        if (item.fullDiscountType === 3) {
          textArr.push(`满${item.fullDiscountConditionList[0].fullAmount}打${item.fullDiscountConditionList[0].discountRate}折`);
        } else if (item.fullDiscountType === 2) {
          textArr.push(`每满${item.fullDiscountConditionList[0].fullAmount}减${item.fullDiscountConditionList[0].discountAmount}`);
        } else if (item.fullDiscountType === 1) {
          textArr.push(`满${item.fullDiscountConditionList[0].fullAmount}减${item.fullDiscountConditionList[0].discountAmount}`);
        }
      });
      return textArr.splice(0, 3).join(' ');
    },
    openActivity(val) {
      this.coursePopType = val;
      this.$nextTick(() => {
        if (val === 'fullReduction') {
          this.$refs.popupRef.show = true;
        } else {
          this.$refs.popupRef.show = true;
        }
      });
    },
    close() {
      this.$refs.popupRef.show = false;
    },
    openCouponAcvitity() {
      this.$refs.couponList.show = true;
    },
    giveCouponList() {
      this.GiveCouponShow = true;
    },
    giveCouponClose() {
      this.GiveCouponShow = false;
    },
    giveGiftsList() {
      this.GiveGiftsShow = true;
    },
    giveGiftsClose() {
      this.GiveGiftsShow = false;
    },
    // 倒计时
    countTime() {
      const { receiveTimeEnd } = this.couponDetail;
      // 当前时间戳
      const now = new Date().getTime();
      // 结束时间戳
      const end = new Date(replaceHyphens(receiveTimeEnd)).getTime();
      // 做判断当倒计时结束时都为0
      if (now >= end) {
        this.showTime = null;
        return;
      }
      // 用结束时间减去当前时间获得倒计时时间戳
      let temp = end - now + 1000;
      this.timers = setInterval(() => {
        temp -= 1000;
        if (temp > 0) {
          this.showTime = timerYhqCount(temp);
        } else {
          this.showTime = null;
          clearInterval(this.timers);
        }
      }, 1000);
    },
  },
  destroyed() {
    clearInterval(this.timers);
  },
};
</script>

<style lang="scss" scoped>
.priceModule-installment {
  /* 分期 */
  display: flex;
  align-items: flex-start;
  width: 100%;
  padding: 0 36px 28px 36px;
  background: #fff;

  .installment-title {
    margin-top: 10px;
    margin-right: 19px;
    // padding-top: 16px;
    color: #333;
    font-weight: 600;
    font-size: 25px;
    line-height: 43px;
  }
  .discount-box {
    display: flex;
    flex: 1;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-start;
    // 分期
    .discount-hb {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      margin-top: 10px;
      margin-bottom: 20px;
      padding-bottom: 2px;
      padding-left: 10px;

      &:last-child {
        margin-bottom: 0;
      }
      .discount-hb-left {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

      .right-icon {
        width: 43px;
      }

      .open {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        span {
          // padding-top: 8px;
          color: #fa8947;
          font-size: 25px;
          white-space: nowrap;
        }
      }
      .installment-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 43px;
        margin: 0 26px 0 0;
        padding: 0 10px;
        color: #ff6c02;
        font-size: 22px;
        background: rgba(255, 126, 32, 0.15);
        border: 1.1px solid #ff6c02;
        border-radius: 4px;
      }
      // .discountAmount {
      //   box-sizing: border-box;
      //   height: 36px;
      //   margin: 0 26px 0 0;
      //   padding: 0 20px;
      //   color: #ff6c02;
      //   font-size: 22px;
      //   line-height: 36px;
      //   white-space: nowrap;
      //   text-align: center;
      //   background: url('../../../assets/img/productDetail/icon_coupon.png') no-repeat center;
      //   background-size: 100% 36px;
      // }
      // .usableCondition {
      //   color: #333;
      //   font-size: 25px;
      //   line-height: 36px;
      //   word-wrap: break-word;
      //   word-break: break-all;
      // }
      .installment-content {
        margin-left: 22px;
        color: #333;
        font-size: 25px;
        line-height: 36px;
      }
    }
  }
}
.taxPreference {
  margin-left: 22px;
  color: #333;
  font-weight: 400;
  font-size: 25px;
  line-height: 36px;
}
.addEllips {
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

::v-deep .van-icon-arrow {
  color: #787878;
  font-size: 19px;
}

.couponBoxWarrp {
  padding-bottom: 36px;
  .couponBoxCenter {
    display: flex;
    align-items: center;
    width: 678px;
    height: 91px;
    margin: 0 auto;
    background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/courseDetail/couponNewBg.png')
      no-repeat center;
    background-size: 100% 100%;
    .couponDisType {
      display: flex;
      align-items: center;
      box-sizing: border-box;
      width: 82%;
      .discountAmount {
        width: 111px;
        color: #fff;
        font-weight: 600;
        font-size: 29px;
        line-height: 49px;
        text-align: center;
        border-radius: 11px 181px 181px 11px;
      }
      .usableCondition {
        margin-bottom: 12px;
        padding-left: 18px;
        color: #fff;
        font-weight: 400;
        font-size: 25px;
      }
      .timeCount {
        padding-left: 18px;
        color: #fff;
        font-weight: 400;
        font-size: 25px;
      }
    }
    .openCouList {
      width: 18%;
      height: 40px;
      margin-right: 22px;
      color: #fff;
      font-weight: 500;
      font-size: 18px;
      line-height: 40px;
      text-align: center;
      background: #fd6a81;
      border-radius: 20px;
    }
  }
}
</style>
